export default {
  PRIMARY: '#1a4a8f',
  GRAY: '#717171',
  GRAY_LIGHTER_20: '#ddd',
};
